module.exports = __webpack_public_path__ + "img/mixBox_bg_dark.1a8fdd1c.png";